/**
 * Trade Endpoints
 */
import { getApiClient } from "../client";
import { TRADE_POPULATE } from "../populate";
import { TradeSchema } from "../schemas";
import { parseStrapiListResponse } from "../utils/parseStrapiResponse";
/**
 * Trade endpoints
 */
export const tradesEndpoints = {
    /**
     * Get trades for a bot config
     */
    async getBotTrades(botConfigId, params) {
        const populate = TRADE_POPULATE.DEFAULT;
        const response = await getApiClient().get(`/trades/bot-configs/${botConfigId}`, {
            params: {
                populate,
                sort: params?.sort ?? ["timestamp:desc"],
                ...params,
            },
        });
        return parseStrapiListResponse(response.data, {
            schema: TradeSchema,
            populate,
            context: "tradesEndpoints.getBotTrades",
        });
    },
};
